import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Stack, Card, CardContent, List, ListSubheader } from "investira.react.components";
import { useEntidadesContext } from "../../contexts/EntidadesContext";
import withResponseHandling from "../../hoc/withResponseHandling";
import withMessage from "../../hoc/withMessage";
import AlertaMembrosListItem from "./AlertaMembrosListItem";
const Membros = memo(props => {
  const {
    state,
    actions
  } = useEntidadesContext();
  const defaultEntidadeId = useSelector(store => store.user.default_entidade_id);
  const {
    data,
    current
  } = useSelector(store => store.entidade);
  function getEntidade(pData = data, pCurrentEntidade = current) {
    const {
      default_entidade_id
    } = pCurrentEntidade;
    const xEntidade = pData.find(xItem => xItem.entidade_id === default_entidade_id);
    return xEntidade;
  }
  function ordenarPorAlertaUsuarios(pUsuarios) {
    return pUsuarios;
  }
  const {
    config = {}
  } = getEntidade();
  const [alertaUsuario, setAlertaUsuarios] = useState(!config?.alerta_usuarios ? [] : String(config.alerta_usuarios).split(",").map(xItem => xItem.trim()));
  const xAlertaUsuarios = alertaUsuario;
  function handleAlert(pUsuario) {
    let xNewAlertaUsuarios = [];
    let xRollback = [];
    setAlertaUsuarios(pPrev => {
      const {
        usuario_id
      } = pUsuario;
      xNewAlertaUsuarios = [...pPrev];
      xRollback = pPrev;
      if (!xNewAlertaUsuarios.includes(String(usuario_id))) {
        xNewAlertaUsuarios.push(String(usuario_id));
      } else {
        xNewAlertaUsuarios = xNewAlertaUsuarios.filter(xUsuarioId => {
          return xUsuarioId !== String(usuario_id);
        });
      }
      return xNewAlertaUsuarios;
    });
    actions.handleModifyEntidade({
      data: {
        config: {
          alerta_usuarios: xNewAlertaUsuarios.join(", ")
        }
      }
    }, null, _rErr => {
      props.onMessageError("Não foi possível atualizar os alertas dos usuários, tente novamente.");
      setAlertaUsuarios(xRollback);
    });
  }
  useEffect(() => {
    actions.readMembros();
  }, [actions.readMembros, alertaUsuario, defaultEntidadeId]);
  const xOrderedUsers = ordenarPorAlertaUsuarios(state.membros);
  return <Stack spacing={2}>
      <Card>
        <CardContent>
          <List disablePadding subheader={<ListSubheader component="div">Membros da entidade</ListSubheader>}>
            {xOrderedUsers.map(xMembro => <AlertaMembrosListItem key={xMembro.username} membro={xMembro} alert={xAlertaUsuarios.includes(String(xMembro.usuario_id))} onClick={() => handleAlert(xMembro)} />)}
          </List>
        </CardContent>
      </Card>
    </Stack>;
});
Membros.propTypes = {};
export default withResponseHandling(withMessage(Membros));
